export enum EprocCategory {
	Direct = "Direct",
	Reed = "Reed",
	SupplyRegister = "Supply Register",
	SupplyBank = "Supply Bank",
	Connex = "Connex",
	EdwinSupply = "Edwin Supply",
}
